import { t } from '@lingui/macro';
import { addShopee } from 'api/api';
import BaseModal from 'component/BaseComponent/BaseModal.js';
import { handleApi } from 'helper/helper';
import React from 'react';
import routes from 'router/routes.js';
import Routes from 'router/routes.js';
import DV from 'variables/DV';
import { trans } from '../../config/LinguiConfig';
import Button from '../../MUI_Kit/components/CustomButtons/Button';

class RedirectToShopeeModal extends BaseModal {
  constructor(props) {
    super(props);
    this.showCloseButton = false;

    this.timer = 0;

    this.goPathWhenClose = this.props.openFromChannels ? Routes.channel.path : Routes.shopee.path;

    this.state = {
      open: false,
      time: 5,
      seconds: 5,
      ...this.getDataFromRouter(),
    };
  }

  async componentDidMount() {
    const { success } = await this.getUrlShopeeAuthorize();
    if (!success) {
      return this.close();
    }
    this.setState({ time: this.state.seconds });
    this.startTimer();
  }

  getUrlShopeeAuthorize = async () => {
    const redirect = window.location.origin + this.goPathWhenClose;
    let { success, data, error } = await handleApi(addShopee({ is_authorize: true, redirect }));
    if (error) {
      DV.showNotify(error, 'danger');
      return { error };
    }
    if (success) {
      if (data.link) {
        await this.setState({ url: data.link, open: true });
      }
      return { success: true };
    }
  };

  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: seconds,
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer);
      window.location.href = this.state.url;
    }
  };

  renderBody() {
    let { open } = this.state;
    return (
      <div>
        {t`Bạn sẽ được chuyển sang website của Shopee (shopee.vn) để tích hợp tài khoản Shopee với DooPage.`}
      </div>
    );
  }

  renderFooter() {
    return (
      <Button
        onClick={() => {
          window.location.href = this.state.url;
        }}
        color="info">
        {t`CHUYỂN ĐẾN SHOPEE` + ' (' + this.state.time + ')'}
      </Button>
    );
  }
}

export default RedirectToShopeeModal;
